/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { generate as generateUniqueId } from 'randomstring'
import { FC, useState } from 'react'
import { findAllPlatforms_findAllPlatforms_items } from '__generatedTypes__/findAllPlatforms'
import { PlatformName } from '__generatedTypes__/globalTypes'
import TabsNavigation from 'components/TabsNavigation'
import { getFullPlatformTitle } from 'components/Layout/Sidebar/PlatformList'
import { TabsItem } from 'types/tabsItem'
import * as classes from './styles'
import TeamMembersList from './TeamMembersList'
import TeamMembersPlatformList from './TeamMembersPlatformList/TeamMembersPlatformList'

interface IProps {
  platforms: findAllPlatforms_findAllPlatforms_items[]
}

const BOOSTER_PREP_TAB = {
  id: generateUniqueId(),
  title: 'Booster Prep (All)',
  slug: '',
}

const TeamMembersContent: FC<IProps> = ({ platforms }) => {
  const [activeTab, setActiveTab] = useState<TabsItem & { slug: string }>(BOOSTER_PREP_TAB)

  const handleChangeTab = (value: TabsItem) => {
    if (value.id === BOOSTER_PREP_TAB.id) {
      setActiveTab(BOOSTER_PREP_TAB)
    }

    const selectedPlatform = platforms.find(({ id }) => id === value.id)
    selectedPlatform && setActiveTab(selectedPlatform)
  }

  return (
    <div css={classes.container}>
      <Typography css={classes.header} variant="title3">
        Team Members
      </Typography>
      <TabsNavigation
        css={classes.tabs}
        tabs={[BOOSTER_PREP_TAB, ...platforms]}
        renderTabTitle={(tab) => getFullPlatformTitle(tab.title as PlatformName)}
        value={activeTab}
        onChange={handleChangeTab}
      />
      {activeTab.id === BOOSTER_PREP_TAB.id ? (
        <TeamMembersList />
      ) : (
        <TeamMembersPlatformList platformId={activeTab.id} platformSlug={activeTab.slug} />
      )}
    </div>
  )
}

export default TeamMembersContent
